function unitLabel(unit) {
  return Number(unit) === 1 ? "kg" : Number(unit) === 2 ? "lbs" : "pcs";
}

export function promotionRuleSummary(promotion) {
  const unit = unitLabel(promotion.selling_unit_of_measure);
  if (promotion.rule_type === "buy_get") {
    return `Buy ${promotion.buy_quantity} ${unit}, get ${promotion.free_quantity} ${unit} free`;
  }
  return (promotion.applied_tier ? [promotion.applied_tier] : promotion.tiers || []).map((tier) =>
    `${tier.minimum_quantity}+ ${unit} @ $${Number(tier.unit_price).toFixed(2)}`
  ).join(" · ") || "Quantity tiers";
}

